import { PureComponent } from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import { signUser } from 'services/authentication';

class SignUser extends PureComponent {
  static propTypes = {
    loginUser: T.func.isRequired,
    params: T.shape({
      token: T.string,
    }),
  };

  componentDidMount() {
    this.attemptLogin();
  }

  componentDidUpdate() {
    this.attemptLogin();
  }

  attemptLogin() {
    this.props.loginUser(this.props.params);
  }

  render() {
    return null;
  }
}

const withStore = connect(
  null,
  {
    loginUser: signUser,
  }
);

export default withStore(SignUser);
